var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 457,
    width: 38,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.159051,
    y: -0.094655,
    width: 371429,
    height: 361905
  })), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHmUExURQAAAP+iov+5uf92dv9JSf/MzP97e/+qqv9qav+urv+AgP+Ghv93d/+iov9qav9ra/8aGv9PT/9UVP+bm/8UFP8gIP9ERP9UVP9qav9fX/9YWP9RUf82Nv9JSf9DQ/9GRv8MDP8nJ/8yMv1JSf1NTf08PP0wMP0zM/4zM/4yMv42Nv4gIP4hIf4qKv4dHf40NP8kJP4nJ/4tLf4gIP4sLP4dHf4ZGf4hIf4WFv4jI/4ICP4JCf4WFv4KCv4BAf4EBP8AAP8BAf8CAv8DA/8EBP8FBf8JCf8KCv8LC/8MDP8ODv8PD/8QEP8REf8SEv8TE/8UFP8VFf8bG/8dHf8hIf8qKv8rK/8uLv8vL/8zM/82Nv84OP86Ov89Pf8+Pv9DQ/9ISP9KSv9NTf9RUf9TU/9bW/9dXf9eXv9iYv9kZP9paf9tbf9ubv9zc/92dv93d/96ev9/f/+Hh/+QkP+Skv+amv+goP+iov+jo/+mpv+np/+oqP+urv+xsf+zs/+0tP+2tv+3t/++vv/Bwf/Kyv/V1f/X1//a2v/b2//c3P/d3f/e3v/f3//g4P/h4f/i4v/k5P/o6P/p6f/s7P/t7f/u7v/v7//z8//19f/39//4+P/5+f/6+v/7+//8/P/9/f/+/v///1x9Co0AAABAdFJOUwALCw0ODx0eKSkqKissNTc6Oj09QEBAQEhWV1tsbXZ5fX2AhYWMmZqztrfFx8fJy8zN1dna2+rq7Ozt+/z9/v4HD/P1AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACkUlEQVRIS6WU51fTcBiFw95777333nDDEJDSyqYgQwSk7CWCqChDGW4QkFXyn5q8eaUj8EWfT7n3PqcnJ/mlwn/gEhiTEB+fEBPowsUDuEUXtINpL4h241qLa5oB6J5c3tja2lie7AYMaa482RFXCf38nnTH3rwelXE8WuOch+alM7aYs6Vm5DmzcId3BQYP2bDicBAV3qwwXuUwXfJsw6UJ5V4sEU4lmOFNwwxKnFhTyMQEDwrf371+/5OvZSaQyZpMFHrOuZf59Uh+qoZbTpJ03oMoFgXH0oZdrhW+0Ru44iSz21DqyGosprgkNKo0hVhWyxr3uSO06n5jmWqGY4wrFa0qjSGc1FRscqNyj7qJVFKL6k+4UfmqVU/qi0jV9XLBfNaqUq9OMYMwzvn6ivhE6vk1caNO4wiS1VDMqvFlawvRTGpLK/H4DW2zCJXVYCxSkp6RYs8L2hYRLKshWKAkPeXRlue0LSBEVsMwTemBX52kbRphsuohjlKSXj0xKOjbSGnXEx1vaRsVPWRV6OyiJB9jhYuLj6Se/Za5uOBn1tWpmEIWDtTMHJJ6zYk4QBapiVjhRuUedQWJpHo2GS3nWEar3hqbPEkVCrHNHXGkUbdRqJpChDhk5lJBPQNWqnlIjGBVyMYatwpf7NU1ZLMoCL5VbVbfgXoILep+W5UvizLJYt8pD5J03CqbHXe3dNonJrNGpGPA4v7Y2vxwzNfS6QDSWVJxyEG/7YtgDvqR48AS45gh6tatnwNhXteJGX//Aywk1WB4x0Y27wyjJolnG/xyRRhXj/gTuTlaNULM9ePRnsjiOqBrxDQ3ZxrpAuqKI3m4D/eU/OpaERBrq/NT3Ll8GJ8Af/8AHw7/giD8AcnRSDRXPR3KAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 352381,
    height: 352381
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-620 -457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000105 0 0 0.000105 620 457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.02703 0 0 1 -0.0664062 -0.0263672)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8390.02 8390.02)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/RedCross.274032716601b19682aaf7ee90901436.svg";
export { ForwardRef as ReactComponent };